import { faPencilAlt, faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@vadiun/react-components';
import { useVerifyAction } from '@vadiun/react-hooks-legacy';
import { Table } from 'shared/components';
import { createDomicilioText } from 'shared/models/DomicilioGoogle';
import { TitularModel } from '../models/Titular';

interface Props {
  titulares: TitularModel[];
  selectToEdit: (x: TitularModel) => void;
  delete: (x: TitularModel) => void;
  restore: (x: TitularModel) => void;
  handlePageChange: (currentPage: number) => void;
}

const TitularTable = (props: Props) => {
  const verifyAction = useVerifyAction();

  const columns = [
    {
      name: 'nombre',
      label: 'Nombre',
      options: {
        filter: false,
        sort: true
      }
    },
    {
      name: 'telefono',
      label: 'Telefono',
      options: {
        filter: false
      }
    },
    {
      name: 'email',
      label: 'Email',
      options: {
        filter: false
      }
    },
    {
      name: 'domicilio',
      label: 'Domicilio',
      options: {
        filter: false
      }
    },
    {
      name: 'isDeleted',
      label: 'Borrado',
      options: {
        display: false,
        filterOptions: {
          names: ['Si', 'No']
        },
        filterList: ['No'],
        customFilterListOptions: { render: (v) => `Borrado: ${v}` }
      }
    },
    {
      label: 'Acciones',
      name: 'id',
      options: {
        filter: false,
        customBodyRenderLite: (index: number) =>
          props.titulares[index].isDeleted ? (
            <Button onClick={() => props.restore(props.titulares[index])}>
              Restaurar
            </Button>
          ) : (
            <div style={{ display: 'flex' }}>
              <Button
                onClick={() => props.selectToEdit(props.titulares[index])}
                shape="circle"
                color="primary"
              >
                <FontAwesomeIcon icon={faPencilAlt} />
              </Button>
              <Button
                onClick={() =>
                  verifyAction({
                    title: 'Estas por eliminar un titular!',
                    body: 'Esta accion va a eliminar el titular. ¿Estas seguro?',
                    onAccept: () => props.delete(props.titulares[index])
                  })
                }
                shape="circle"
                color="red"
              >
                <FontAwesomeIcon icon={faTrash} />
              </Button>
            </div>
          )
      }
    }
  ];

  const data = props.titulares.map((x) => ({
    ...x,
    isDeleted: x.isDeleted ? 'Si' : 'No',
    domicilio: createDomicilioText(x.domicilio)
  }));

  return (
    <div className="w-full">
      <Table
        options={{
          elevation: 0,
          selectableRows: 'none',
          onChangePage: props.handlePageChange,
        }}
        title={'Titulares'}
        data={data}
        columns={columns}
      />
    </div>
  );
};

export default TitularTable;
